'use client';

import { useEffect } from 'react';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('Global Error Boundary Caught:', error);
    }, [error]);

    return (
        <div style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '24px', textAlign: 'center' }}>
            <div style={{ maxWidth: '600px', background: 'var(--color-bg-surface)', padding: '40px', borderRadius: '12px', border: '1px solid var(--color-border-subtle)' }}>
                <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '16px', color: 'var(--color-text-main)' }}>Oops! Something went wrong</h2>
                <p style={{ color: 'var(--color-text-muted)', marginBottom: '24px' }}>
                    We apologize for the inconvenience. An unexpected problem occurred during your request.
                </p>
                <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
                    <button
                        onClick={() => reset()}
                        style={{ background: 'var(--color-primary)', color: 'white', padding: '10px 20px', borderRadius: '6px', fontWeight: 500, cursor: 'pointer', border: 'none' }}
                    >
                        Try again
                    </button>
                    <a
                        href="/"
                        style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '10px 20px', borderRadius: '6px', fontWeight: 500, cursor: 'pointer', border: '1px solid var(--color-border-subtle)', color: 'var(--color-text-main)', textDecoration: 'none' }}
                    >
                        Return Home
                    </a>
                </div>
            </div>
        </div>
    );
}
